import React, { useState } from 'react'
import { font } from './constants'

function TagInput({ label, placeholder, helpText, required, tags, onAdd, onRemove, disabled = false }) {
  const [input, setInput] = useState('')

  const handleKey = e => {
    if (disabled) return
    if ((e.key === 'Enter' || e.key === ',') && input.trim()) {
      e.preventDefault()
      onAdd(input.trim())
      setInput('')
    }
    if (e.key === 'Backspace' && !input && tags.length > 0) {
      onRemove(tags.length - 1)
    }
  }

  return (
    <div style={{ marginBottom: 20, cursor: disabled ? 'not-allowed' : undefined }}>
      <label style={{ display: 'block', fontSize: 13, color: '#6b6b6b', marginBottom: 6, fontFamily: font }}>
        {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
      </label>
      <div
        style={{
          background: 'rgba(0,0,0,0.04)',
          border: '1px solid rgba(0,0,0,0.1)',
          borderRadius: 8,
          padding: '8px 10px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 6,
          alignItems: 'center',
          minHeight: 42,
          cursor: disabled ? 'not-allowed' : undefined,
          opacity: disabled ? 0.85 : 1,
        }}
      >
        {tags.map((tag, i) => (
          <span
            key={i}
            style={{
              background: 'rgba(239,68,68,0.15)',
              color: '#ef4444',
              fontSize: 12,
              padding: '4px 10px',
              borderRadius: 20,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontFamily: font,
              border: '1px solid rgba(239,68,68,0.2)',
            }}
          >
            {tag}
            <span
              onClick={() => !disabled && onRemove(i)}
              style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: 0.7, fontSize: 14, lineHeight: 1 }}
              role="presentation"
            >
              ×
            </span>
          </span>
        ))}
        <input
          value={input}
          onChange={e => !disabled && setInput(e.target.value)}
          onKeyDown={handleKey}
          placeholder={tags.length === 0 ? placeholder : 'Add another...'}
          disabled={disabled}
          style={{
            background: 'transparent',
            border: 'none',
            outline: 'none',
            color: '#363636',
            fontSize: 14,
            flex: 1,
            minWidth: 120,
            fontFamily: font,
            cursor: disabled ? 'not-allowed' : 'text',
          }}
        />
      </div>
      {helpText && (
        <p style={{ fontSize: 11, color: '#999999', marginTop: 4, fontFamily: font, lineHeight: 1.4 }}>{helpText}</p>
      )}
    </div>
  )
}

export default TagInput
